import { DataSource, FiltrosModel } from '@/datasources/consulte-grid';
import { GesParametrosModel } from '@/models/gesparametros/gesparametros.model';
import { IPesquisaParametroResposta } from '@/models/gesparametros/pesquisaparametro.model';
import api from '@/services/axios/api';
import { AxiosResponse } from 'axios';
import { RegisterOutput } from '@/models/register-output';
import TextoValor from '@/models/texto-valor';

class GesParametrosService {
  dadosIndexPaginado(
    pagina: number,
    itensPorPagina: number,
    filters: FiltrosModel[],
    sortDataField?: string,
  ): Promise<AxiosResponse<DataSource<GesParametrosModel>>> {
    return api.post<DataSource<GesParametrosModel>>('/GesParametros/RetornoPaginado', {
      rowsPerPage: itensPorPagina,
      pageNumber: pagina,
      filters: filters,
      sortDataField: sortDataField,
    });
  }

  // Atualiza o valor de um parâmetro pelo PK local (`codigoParametro` = GESPARAMETROS.CODIGO), que já
  // precisa existir para a escola/ano. Resolva o PK antes via `getParametro` (por código do catálogo).
  inserirAtualizar(
    codigoParametro: number,
    valorAtualizado: string,
  ): Promise<AxiosResponse<RegisterOutput>> {
    return api.put('/GesParametros', { codigoParametro: codigoParametro, valor: valorAtualizado });
  }

  async get(id: number): Promise<GesParametrosModel> {
    const result = await api.get<GesParametrosModel>(`/GesParametros/${id.toString()}`);
    return result.data;
  }

  async getParametro(
    codigoPar: number,
    codEscola: number,
    ano: number
  ): Promise<GesParametrosModel> {

    const result = await api.get<GesParametrosModel>(
      `/GesParametros/${codigoPar}/${codEscola}/${ano}`
    );

    return result.data;
  }

  async listarCategorias(): Promise<TextoValor[]> {
    const result = await api.get<TextoValor[]>('/GesParametros/Categorias');
    return result.data;
  }

  /**
   * Replica UM parâmetro para TODAS as escolas da rede, no ano informado — criando o registro na
   * escola que ainda não o tem.
   *
   * O `codigoPar` é o código do CATÁLOGO (o mesmo de `ConfiguracaoEscolaCodigo`), e não o PK
   * local: o PK existe por escola, e aqui o alvo são todas elas.
   *
   * O VALOR vai da tela, e não é relido no servidor: quem clica acabou de editar o campo, e
   * reler traria o valor anterior. A tela salva antes e manda o mesmo valor.
   */
  async replicarParametroParaTodasEscolas(
    codigoPar: number,
    ano: number,
    valor: string,
  ): Promise<AxiosResponse<{ sucesso: boolean; mensagem: string; totalEscolas: number }>> {
    return api.post('/GesParametros/ReplicarParametroTodasEscolas', {
      codigoPar,
      ano,
      valor,
    });
  }

  async replicarParametros(
    codigoEscolaOrigem: number,
    codigosEscolaDestino: number[],
    anoParametro: number,
  ): Promise<AxiosResponse<RegisterOutput>> {
    return api.post('/GesParametros/ReplicarParametros', {
      codigoEscolaOrigem,
      codigosEscolaDestino,
      anoParametro,
    });
  }

  async pesquisarPorNome(
    nome: string,
    ano: string,
    codigoEscola: string,
  ): Promise<IPesquisaParametroResposta[]> {
    // Todos os parâmetros cujo nome CONTÉM o texto, sem diferenciar acento nem caixa.
    const result = await api.get<IPesquisaParametroResposta[]>('/GesParametros/Nome', {
      params: { nome, ano, codigoEscola },
    });
    return Array.isArray(result.data) ? result.data : [];
  }
}

export default new GesParametrosService();
